import MobileVehicleView from './MobileVehicleView';
export default MobileVehicleView;
